import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Seoul";

export function getInitialDateTimeRange() {
  const now = dayjs().tz(TZ);

  return {
    start: now.startOf("day").format("YYYY-MM-DDTHH:mm"),
    end: now.format("YYYY-MM-DDTHH:mm"),
  };
}

export function getPresetDateTimeRange(type) {
  const now = dayjs().tz(TZ);

  if (type === "today") {
    return {
      start: now.startOf("day").format("YYYY-MM-DDTHH:mm"),
      end: now.format("YYYY-MM-DDTHH:mm"),
    };
  }

  if (type === "yesterday") {
    const y = now.subtract(1, "day");
    return {
      start: y.startOf("day").format("YYYY-MM-DDTHH:mm"),
      end: y.endOf("day").format("YYYY-MM-DDTHH:mm"),
    };
  }

  if (type === "week") {
    return {
      start: now.subtract(6, "day").startOf("day").format("YYYY-MM-DDTHH:mm"),
      end: now.format("YYYY-MM-DDTHH:mm"),
    };
  }

  return getInitialDateTimeRange();
}